<template>
    <Zxconsultation/>
</template>
<script>
import Zxconsultation from 'place/evaluation/zxconsultation.vue'
export default {
    components:{
        Zxconsultation
    }
}
</script>
t